export const $ = (sel, ctx = document) => ctx.querySelector(sel);
export const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

export function el(html) {
  const box = document.createElement('div');
  box.innerHTML = html.trim();
  return box.firstElementChild;
}

export const wrapEach = (items, tag) => items.map((item) => `<${tag}>${item}</${tag}>`).join('');

export function activate(nodes, isOn, aria) {
  nodes.forEach((node, i) => {
    const on = isOn(node, i);
    node.classList.toggle('is-on', on);
    if (aria) node.setAttribute(aria, String(on));
  });
}
